module.exports = __webpack_public_path__ + "static/toggl-34768c148baa9c06210b447eab482d39.png";